import { css } from "lit";

export const styles = css`
  .section-divider {
    border: none;
    border-top: 1px solid var(--sds-color-border-default-default);
    margin: var(--sds-size-space-400) var(--section-divider-margin-left, 0) var(--sds-size-space-400)
      var(--section-divider-margin-right, 0);
    padding: 0;
  }

  .toggle-field {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .toggle-field wow-switch {
    --wow-switch-border-top: none;
  }

  .co-promotion-search-trigger {
    cursor: pointer;
  }

  .co-promotion-search-trigger wow-input {
    pointer-events: none;
  }

  .selected-collaborators-summary {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
  }
`;
